<template>
  <SearchPage
    endpoint="events"
    :title="node.title"
    :group-by="{
      field: 'date',
      hide: true,
    }"
    list-class="grid md:grid-cols-2 xl:grid-cols-3 gap-x-20 [&>li]:pb-20 [&>li]:row-span-9 [&>li]:grid [&>li]:grid-rows-subgrid [&>li]:grid-cols-1"
    :filter-titles="{
      date: $texts('filter.fromDate', 'Ab Datum'),
      organization: $texts('filter.eventOrganizator', 'Organisation'),
    }"
    :search-result-titles="{
      singular: $texts('eventsSingular', 'Veranstaltung'),
      plural: $texts('eventsPlural', 'Veranstaltungen'),
    }"
  >
    <template #default="{ hit }">
      <EventTeaser v-bind="hit" />
    </template>
    <template #no-results>
      <EventNoResultsBox :for-date="new Date()" />
    </template>
  </SearchPage>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'event-calendar-overview',
  drupalFrontendRoute: true,
  ariaLive: 'off',
  languageMapping: {
    de: '/veranstaltungen',
    fr: '/fr/evenements',
    it: '/it/eventi',
    en: '/en/events',
  },
})

const { entity: node } = await useDrupalRouteQuery('page')

await renderPageDependencies()
</script>
